var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChairIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.057 3.387a2.91 2.91 0 0 1 5.74-.956l2.115 6.98h8.522a2.941 2.941 0 0 1 0 5.883v2.708c0 .325-.444.821-.77.821H11.14v.589a.588.588 0 0 1-.588.588H9.374a.588.588 0 0 1-.588-.588v-.589h-4.5c-.325 0-.794-.587-.794-.911v-2.618a.588.588 0 0 1-.58-.492L.057 3.387z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.302 16.19a.952.952 0 0 0-.952-.952H6.683a.952.952 0 0 0 0 1.905h6.667a.952.952 0 0 0 .952-.953zM4.212 13.428 1.729 3.571c-.126-.7.454-1.337 1.216-1.337.604 0 1.118.406 1.217.96l2.074 7.57a.411.411 0 0 0 .413.326h9.856c.694 0 1.256.524 1.256 1.17 0 .645-.562 1.168-1.256 1.168H4.212z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairIcon3);
export default __webpack_public_path__ + "static/media/chair-icon-3.9ba0dd92a340cfc934244ccb3a810c24.svg";
export { ForwardRef as ReactComponent };